module.exports = __webpack_public_path__ + "img/bt.bde3270a.png";